"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TurretOrchestrator = void 0;
var tslib_1 = require("tslib");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var TurretOrchestrator = (function () {
    function TurretOrchestrator() {
    }
    TurretOrchestrator.prototype.ApplySignature = function (publicKey, signature, tx) {
        if (!publicKey) {
            throw new Error("public key cannot be null");
        }
        if (!signature) {
            throw new Error("signature cannot be null");
        }
        tx.addSignature(publicKey, signature);
    };
    TurretOrchestrator.prototype.ExecuteContractAsync = function (turret, request, authToken, contractHash) {
        var _a, _b, _c, _d, _e;
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var config, postUrl, resp, result, err_1, axiosErr, result;
            return (0, tslib_1.__generator)(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        config = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: "Bearer ".concat(authToken),
                            },
                        };
                        postUrl = turret.rootUrl + "/tx-functions/" + contractHash;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        return [4, axios_1.default.post(postUrl, request, config)];
                    case 2:
                        resp = _f.sent();
                        result = {
                            turret: turret,
                            statusCode: resp.status,
                            error: "",
                            response: resp.data,
                        };
                        return [2, result];
                    case 3:
                        err_1 = _f.sent();
                        axiosErr = err_1;
                        result = {
                            turret: turret,
                            statusCode: (_b = (_a = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 500,
                            error: (_e = (_d = (_c = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : "Unknown failure reason",
                            response: undefined,
                        };
                        return [2, result];
                    case 4: return [2];
                }
            });
        });
    };
    TurretOrchestrator.prototype.ExecuteGetFeeBalanceAsync = function (turret, authToken) {
        var _a, _b, _c, _d, _e;
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var config, url, resp, result, err_2, axiosErr, result;
            return (0, tslib_1.__generator)(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        config = {
                            method: "GET",
                            headers: {
                                authorization: "Bearer ".concat(authToken, "\u00E5"),
                            },
                        };
                        url = turret.rootUrl + "/tx-fees";
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        return [4, axios_1.default.get(url, config)];
                    case 2:
                        resp = _f.sent();
                        result = {
                            turret: turret,
                            statusCode: resp.status,
                            error: "",
                            response: resp.data,
                        };
                        return [2, result];
                    case 3:
                        err_2 = _f.sent();
                        axiosErr = err_2;
                        result = {
                            turret: turret,
                            statusCode: (_b = (_a = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 500,
                            error: (_e = (_d = (_c = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : "Unknown failure reason",
                            response: undefined,
                        };
                        return [2, result];
                    case 4: return [2];
                }
            });
        });
    };
    TurretOrchestrator.prototype.ExecutePayFeeBalanceAsync = function (turret, publicKey, paymentXdr) {
        var _a, _b, _c, _d, _e;
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var config, request, postUrl, resp, result, err_3, axiosErr, result;
            return (0, tslib_1.__generator)(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        config = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                        };
                        request = {
                            txFunctionFee: paymentXdr,
                        };
                        postUrl = turret.rootUrl + "/tx-fees/" + publicKey;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        return [4, axios_1.default.post(postUrl, request, config)];
                    case 2:
                        resp = _f.sent();
                        result = {
                            turret: turret,
                            statusCode: resp.status,
                            error: "",
                            response: resp.data,
                        };
                        return [2, result];
                    case 3:
                        err_3 = _f.sent();
                        axiosErr = err_3;
                        result = {
                            turret: turret,
                            statusCode: (_b = (_a = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 500,
                            error: (_e = (_d = (_c = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : "Unknown failure reason",
                            response: undefined,
                        };
                        return [2, result];
                    case 4: return [2];
                }
            });
        });
    };
    return TurretOrchestrator;
}());
exports.TurretOrchestrator = TurretOrchestrator;
//# sourceMappingURL=TurretOrchestrator.js.map